import {
  ComponentConfig,
  LayoutTypes,
  ComponentType,
  FlexDirection,
  InputType,
} from "../services/types/ComponentTypes";

export const screen_182_stock_correction_add: any[] = [
    {
        "componentType": "screenGroup",
        "title": "Add Stock Correction",
        "style": {
            "backgroundColor": "#F9FAFB"
        },
        "childComponents": [
            {
                "componentType": "form",
                "Name": "stock_correction",
                "TableName": "stock_correction",
                "Plugins": [
                    {
                        "type": "api"
                    }
                ],
                "columnNumber": "m1 t1 w1",
                "style": {
                    "padding": 16,
                    "backgroundColor": "#ffffff",
                    "direction": "column",
                    "borderRadius": 12
                },
                "Fields": [
                    {
                        "componentType": "fieldGroup",
                        "Label": "Stock Correction Details",
                        "BindValue": "con_stock_correction",
                        "style": {
                            "direction": "column"
                        },
                        "childComponents": [
                            {
                                "componentType": "searchableDropdown",
                                "name": "drp_product",
                                "label": "Product",
                                "placeholder": "Select Product",
                                "required": true,
                                "lookupName": "product_itemcode",
                                "options": [],
                                "searchable": true,
                                "clearable": true,
                                "Json_Attribute": "product_id",
                                "BindValue": "drp_product"
                            },
                            {
                                "componentType": "searchableDropdown",
                                "name": "drp_batch",
                                "label": "Batch",
                                "placeholder": "Select Batch",
                                "lookupName": "product_batch_stock_display",
                                "parentField": "drp_product",
                                "options": [],
                                "searchable": true,
                                "clearable": true,
                                "Json_Attribute": "batch_id",
                                "BindValue": "drp_batch"
                            },
                            {
                                "componentType": "textField",
                                "name": "txt_available_qty",
                                "label": "Available Qty",
                                "placeholder": "",
                                "required": false,
                                "inputType": "number",
                                "disabled": true,
                                "BindParent": {
                                    "drp_batch": "available_qty"
                                },
                                "BindValue": "txt_available_qty"
                            },
                            {
                                "componentType": "selectDropdown",
                                "name": "drp_action",
                                "label": "Action",
                                "placeholder": "Select Action",
                                "required": true,
                                "options": [
                                    {
                                        "label": "Addition",
                                        "value": "addition"
                                    },
                                    {
                                        "label": "Removal",
                                        "value": "removal"
                                    }
                                ],
                                "Json_Attribute": "stock_action",
                                "BindValue": "drp_stock_action"
                            },
                            {
                                "componentType": "textField",
                                "name": "txt_qty",
                                "label": "Quantity",
                                "placeholder": "Enter quantity",
                                "required": true,
                                "inputType": "number",
                                "Json_Attribute": "quantity",
                                "BindValue": "txt_qty",
                                "validation": [
                                    {
                                        "rule": "maxValue",
                                        "maxValueField": "txt_available_qty",
                                        "conditionalOn": {
                                            "field": "drp_stock_action",
                                            "value": "removal"
                                        },
                                        "message": "Quantity cannot exceed available batch stock"
                                    }
                                ]
                            },
                            {
                                "componentType": "textField",
                                "name": "txt_remarks",
                                "label": "Remarks",
                                "placeholder": "Enter remarks",
                                "required": false,
                                "inputType": "text",
                                "Json_Attribute": "remarks",
                                "BindValue": "txt_remarks",
                                "IsVerticalView": true
                            }
                        ]
                    }
                ]
            },
            {
                "componentType": "group",
                "style": {
                    "direction": "row",
                    "gap": 10,
                    "marginTop": 10
                },
                "childComponents": [
                    {
                        "componentType": "button",
                        "name": "Submit",
                        "Label": "Submit",
                        "BindValue": "btn_submit",
                        "onPressAction": "save",
                        "Navigate": "181",
                        "ActionType": "Add",
                        "ScreenId": "182",
                        "style": {
                            "backgroundColor": "#22c55e",
                            "textColor": "#FFFFFF",
                            "padding": 12,
                            "borderRadius": 8
                        }
                    }
                ]
            }
        ]
    }
];
